import { Build } from "@stencil/core";

const ASSETS_FOLDER = "gx-ide-assets/";
const COMPONENT_PREFIX = "gx-ide-";
const DEFAULT_LANGUAGE = "en";
const LANGS_FOLDER = "langs/";
const LANG_PREFIX = ".lang.";
const LANG_EXTENSION = ".json";

export class Locale {
  public static commonAssetsPath = "";

  private static getLang(): string {
    const lang =
      document
        .getElementsByTagName("html")[0]
        .getAttribute("lang")
        ?.valueOf() ?? DEFAULT_LANGUAGE;

    // Normalize en-US
    return lang === "en-US" ? "en" : lang;
  }

  private static getStrings(
    component: string,
    lang: string,
    folder: string
  ): Promise<any> {
    if (folder === "") {
      folder = `${component}/`;
    }
    const path =
      `${ASSETS_FOLDER}${folder}${LANGS_FOLDER}${component}${LANG_PREFIX}${lang}${LANG_EXTENSION}` as const;

    return new Promise((resolve, reject): void => {
      fetch(Build.isTesting ? "/build/" + path : path).then(langFile => {
        if (langFile.ok) {
          resolve(langFile.json());
        } else {
          reject();
        }
      }, reject);
    });
  }

  public static async getComponentStrings(
    element: HTMLElement,
    folder = "",
    component = ""
  ): Promise<any> {
    if (component === "") {
      component = element.tagName.toLowerCase().replace(COMPONENT_PREFIX, "");
    }
    const lang = Locale.getLang();
    return await Locale.getStrings(component, lang, folder);
  }

  public static format(text: string, parms: string[]): string {
    let ret: string = text;
    parms.forEach(parm => {
      ret = ret.replace(`{${parms.indexOf(parm)}}`, parm);
    });
    return ret;
  }
}
